import { selectorOSStyles } from "../../utils/styles"

const Selector = ({
  setScreen = () => {},
  screen,
  toChange,
  rolUsuario
}) => {
  const classes = selectorOSStyles()

  const change = (ventana) => {
    const esMecanico = rolUsuario?.toLowerCase() === "mecanico"
    const rutasRestringidas = ["OrdenCompraServ", "OtroTaller"]

    if (esMecanico && rutasRestringidas.includes(ventana)) {
      alert("No tienes permisos para acceder a esta sección.")
      return
    }

    let validaciones = toChange()

    if (["DatosOrdenServicio"].includes(ventana)) {
      setScreen(ventana)
      return
    }

    if (validaciones?.dg) {
      setScreen(ventana)
    }
  }

  return (
    <div className={classes.tabsWrapper}>
      <div className={classes.tabsContainer}>
        <button
          onClick={() => change("DatosOrdenServicio")}
          className={`${classes.tabButton} ${
            screen === "DatosOrdenServicio" ? classes.tabButtonActive : ""
          }`}
        >
          Datos Orden de Servicio
        </button>

        <button
          onClick={() => change("Inspeccion")}
          className={`${classes.tabButton} ${
            screen === "Inspeccion" ? classes.tabButtonActive : ""
          }`}
        >
          Inspecciones/Diagnósticos
        </button>

        <button
          onClick={() => change("Refaccion")}
          className={`${classes.tabButton} ${
            screen === "Refaccion" ? classes.tabButtonActive : ""
          }`}
        >
          Refacciones
        </button>

        <button
          onClick={() => change("Observacion")}
          className={`${classes.tabButton} ${
            screen === "Observacion" ? classes.tabButtonActive : ""
          }`}
        >
          Correcciones
        </button>

        <button
          onClick={() => change("ManoObra")}
          className={`${classes.tabButton} ${
            screen === "ManoObra" ? classes.tabButtonActive : ""
          }`}
        >
          Manos de Obra
        </button>

        <button
          disabled={rolUsuario?.toLowerCase() === "mecanico"}
          onClick={() => change("OrdenCompraServ")}
          className={`${classes.tabButton} ${
            screen === "OrdenCompraServ" ? classes.tabButtonActive : ""
          }`}
        >
          Orden de Compra
        </button>

        <button
          disabled={rolUsuario?.toLowerCase() === "mecanico"}
          onClick={() => change("OtroTaller")}
          className={`${classes.tabButton} ${
            screen === "OtroTaller" ? classes.tabButtonActive : ""
          }`}
        >
          Facturas
        </button>

        <button onClick={() => change("CierreOrden")} className={`${classes.tabButton} ${screen === "CierreOrden" ? classes.tabButtonActive : ""}`}>Finalizar orden</button>
      </div>
    </div>
  )
}

export default Selector
